import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=4547b3de&scoped=true&"
import script from "./DataTable.vue?vue&type=script&lang=ts&"
export * from "./DataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4547b3de",
  null
  
)

export default component.exports